module.exports = __webpack_public_path__ + "bd190ee422f5831ce08b282e6300eff5-markers_img_2_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/markers/assets/markers_img_2_2x.png
// module id = 693
// module chunks = 0